import { Injectable, EventEmitter  } from '@angular/core';

@Injectable()
export class ExibirMenuService {

  mostrarItens = new EventEmitter<any>();
  private itensVisiveis: boolean = false;

  constructor() {
  }

  getItensVisiveis() {
    return this.itensVisiveis;
  }

  setItensVisiveis(val: boolean) {
    this.itensVisiveis = val;
    this.mostrarItens.emit(val);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/shared/exibir-menu.service.ts